import { AppComponent } from "./app.component";
import { AlertComponent } from './alert/alert.component';
import { AlertFilterComponent } from './alert/alert-filter.component';
import { AlertCollectionComponent } from './alert/alert-collection.component';


export const components = [
	// caution: think about adding stuff here - they will add to the app's initial loading time.
	// would it be better to create new feature module? 
	AlertComponent,
	AlertFilterComponent,
	AlertCollectionComponent,
]

export { AppComponent }